import React, { useState } from 'react'
import { StyleSheet, View, Text, ScrollView } from 'react-native'
import { Button, Title, Description, Space, HorizontalLine, MenuList, HorizontalLineSpacer } from '@sart/components'
import { useContent } from '@sart/content'
import { Linking } from 'react-native'

import { SafeAreaView } from 'react-native-safe-area-context'

import { adaptive, backgroundColors, colors, typography } from '@sart/styles'

import AppConfig from '../Configuration'

export default function HelpScreen(props) {
  const { navigation } = props

  const [activeSections, setActiveSections] = useState([])
  const content = useContent()

  const sections = [
    // {id: 'Usage', label: 'Usage' },
    // {id: 'callCenter', label: content.help.contactCallCenterTitle },
    // {id: 'whatsApp', label: content.help.contactWhatsAppTitle },
    {id: 'aboutUs', label: content.help.learnAboutUs },
    {id: 'chat', label: content.help.chat },
  ]

  function handleNavigation (section) {
    if (section.id === 'callCenter') {
      Linking.openURL(`tel:${AppConfig.callCenterNumber}`)
    } else if (section.id === 'whatsApp') {
      Linking.openURL(`https://wa.me/${AppConfig.whatsAppNumber}`)
    } else if (section.id === 'aboutUs') {
      setActiveSections(!activeSections)
    } else if (section.id === 'chat') {
      Linking.openURL('https://www.bikermobile.com/im_livechat/support/4')
    }
  }
  return (
    <ScrollView style={styles.container}>
      <SafeAreaView style={styles.container}>
        <View style={styles.wrapper}>
          <Space height={styles.spaceHeight.height} />
          <Space height={styles.spaceHeightHelp.height} />      
          <Title style={styles.title}>{content.help.title}</Title>
          <Space height={16} />      
          <MenuList color={colors.brightOrange}>
          {
            sections.map(section =>
              <MenuList.Item
                key={section.id}
                label={section.label}
                onPress={() => handleNavigation(section)}
                style={styles.menuListItemStyle}
              />
            )
          }
        </MenuList>
        {!activeSections &&
          <Description style={styles.description}>
            {content.help.learnAboutUsDescription}
          </Description>
        }
        <HorizontalLineSpacer color={colors.brightOrange} style={styles.line} />
        <Description style={styles.link} onPress={() => Linking.openURL("https://bikermobile.com")}>
          {content.help.visitWebsite}
        </Description>
        </View>
      </SafeAreaView>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding
  },
  wrapper: {
    flex: 1
  },
  title: {
    color: colors.brightOrange,
    ...typography.extrabold,
    fontSize: 22
  },
  description: {
    paddingTop: 5,
    textAlign: 'center',
    ...typography.demi,
    color: colors.brightOrange
  },
  link: {
    paddingTop: 5,
    textAlign: 'center',
    fontSize: 16,
    ...typography.lightbold,
    color: colors.brightOrange
  },
  button: {
    backgroundColor: colors.brightOrange,
  },
  menuListItemStyle: {
    fontSize: 16,
    ...typography.lightbold,
    color: colors.brightOrange
  },
  spaceHeight: {
    ...adaptive.spaceHeight
  },
  spaceHeightHelp: {
    ...adaptive.spaceHeightHelp
  },
  line: {
    height: 6
  }
})
